import React from 'react';
import { IconButton, Button } from '@mui/material';
import { Icons, PriceLabel } from 'components';

let starStyle = 'primary';

const columns = (
  onClickDetail = () => { },
  onClickTransfer = () => { },
  putDefaultList = () => { },
  actionsList,
  classes,
  setShowDialog,
  setDataDialog,
  currencyText
) => [
    {
      title: 'ردیف',
      field: 'num',
      filtering: false,
      sorting: false,
      align: 'center',
      cellStyle: {
        width: '1%',
      },
      headerStyle: {
        width: '1%',
      },
    },
    {
      title: 'شناسه',
      field: 'id',
      align: 'center',
      filtering: false,
    },
    {
      title: 'تاریخ شروع',
      field: 'startDate', // 1384
      align: 'center',
      dir: 'ltr',
      filtering: false,
      render: (rowData) => (
        <small>
          <bdi style={{ fontSize: '13px' }}>
            {rowData.startDate} {rowData.startTime}
          </bdi>
        </small>
      )
    },
    {
      title: 'تاریخ انقضا',
      field: 'expireDate', // 1384
      align: 'center',
      dir: 'ltr',
      filtering: false,
      render: (rowData) => (
        <small>
          <bdi style={{ fontSize: '13px' }}>
            {rowData.expireDate} {rowData.expireTime}
          </bdi>
        </small>
      )
    },
    {
      title: 'تخصیص‌دهنده',
      field: 'assignedFrom', // 1384
      align: 'center',
      filtering: false,
    },
    {
      title: `به میزان - ${currencyText}`,
      field: 'amount', // 1384
      align: 'center',
      filtering: false,
      render: (rc) => <PriceLabel amount={rc?.amount} />,
    },
    {
      title: `میزان مصرف - ${currencyText}`,
      field: 'usageAmount', // 1384
      align: 'center',
      filtering: false,
      render: (rc) => <PriceLabel amount={rc?.usageAmount} />,
    },
    {
      title: 'وضعیت',
      field: 'activeStatus', // 1384
      align: 'center',
      cellStyle: {
        width: '1%',
      },
      headerStyle: {
        width: '1%',
      },
      filtering: false,
      render: (rc) =>
        rc?.activeStatus === '1'
          ? 'فعال'
          : `غیر فعال`,
    },
    {
      title: 'گزارش‌گیری',
      field: 'export', // 13
      filtering: false,
      align: 'center',
      sorting: false,
      render: (rd) => (
        <Button
          onClick={(e) => {
            onClickDetail(rd.delegationId);
            e.stopPropagation();
          }}
        >
          نمایش گزارش
        </Button>
      ),
    },
    ...(actionsList['transferAccountDelegationBtn'] ? [{
      title: 'انتقال اعتبار',
      field: 'transfer',
      filtering: false,
      align: 'center',
      sorting: false,
      render: (rd) => (
        <Button
          onClick={(e) => {
            onClickTransfer(rd);
            e.stopPropagation();
          }}
        >
          انتقال به سایرین
        </Button>
      ),
    }] : []),

    ...(actionsList['defaultAccountDelegationBtn'] ? [{
      title: '',
      filtering: false,
      align: 'center',
      sorting: false,
      render: (rd) => (
        <IconButton
          onClick={(e) => {
            if (!rd?.default) {
              putDefaultList(rd?.delegationId);
            } else {
            }
            e.stopPropagation();
          }}
          size="large">
          <Icons icon='startEmpty' color={!rd?.default ? starStyle : 'secondary'} size='20' />
        </IconButton>
      ),
    }] : []),
    ...((actionsList['detailAccountDelegationBtn']) ? [{
      title: 'عملیات',
      field: 'operationSmall',
      filtering: false,
      sorting: false,
      align: 'right',
      cellStyle: {
        width: '1%',
      },
      headerStyle: {
        width: '1%',
      },
      render: (rowData) => (
        <Button startIcon={<Icons icon="MoreHorizontal" color="#667585" size="20" />} variant="contained" className={classes.expandBtn}
          onClick={() => {
            setShowDialog(true);
            setDataDialog(rowData)
          }}
        >
          جزئیات
        </Button>
      ),
    }] : []),


  ];

const columnsId = {
  invoiceId: '1349',
  tax: '1444',
  invoiceStatus: '1352',
  guildName: '1353',
  decreased: '1354',
  hasMultiInvoice: '1384',
};

const orderingIndexes = [
  null,
  'زمان شروع',
  'زمان انقضا',
  'نام و نام خانوادگی',
  'میزان',
  'استفاده شده',
  'تعداد شارژ مجدد',
  'وضعیت',
  null,
  null,
];

const generateData = (rows, query) => {
  return rows.map((row, key) => {
    return {
      num: query?.page * query?.pageSize + key + 1,
      id: row?.['delegationrule_id'],
      startDate: row?.['delegationrule_creationdate_persian_date'],
      startTime: row?.['delegationrule_creationdate_persian_time'],
      expireDate: row?.['delegationrule_expirationdate_persian_date'],
      expireTime: row?.['delegationrule_expirationdate_persian_time'],
      assignedFrom: row?.['owner_business_name'],
      amount: row?.['delegationrule_amount'],
      usageAmount: row?.['delegationrule_used_amount'],
      periodId: row?.['period_name'],
      activeStatus: row?.['delegationrule_is_active'],
      delegationId: row?.['delegationrule_id'],
      default: row?.['delegationrule_is_default'] ? Number(row?.['delegationrule_is_default']) : 0

    };
  });
};

export { columns, columnsId, generateData, orderingIndexes };
